import { render } from "./FilterAreaSalesman.vue?vue&type=template&id=a3b7aaf4"
import script from "./FilterAreaSalesman.vue?vue&type=script&lang=js"
export * from "./FilterAreaSalesman.vue?vue&type=script&lang=js"
script.render = render

export default script